export default __webpack_public_path__ + "static/media/Header-13.3b59dbbb.jpg";